import {Settings} from '@fantasmagames/slot/src/common/settings/Settings';
import {RecodeAnalyticsModule} from '@fantasmagames/slot/src/integration/analytics/RecodeAnalyticsModule';

export class GameRecodeAnalyticsModule extends RecodeAnalyticsModule {
	protected setCurrentModes(): void {
		// TODO: Get RMM value.
		// const isQuickSpinAvailable = (window as any).V.API.get

		(window as any).V.API.SlotAnalytics.setCurrencyMode('Credits');
		const hasQuickSpin: boolean = this.settings.get(Settings.IS_QUICKSPIN_AVAILABLE);
		(window as any).V.API.SlotAnalytics.setQuickSpins(hasQuickSpin); // But depends on regulated market settings.
		(window as any).V.API.SlotAnalytics.setGameSounds(Settings.SOUNDS_ON);
		(window as any).V.API.SlotAnalytics.setBackgroundSounds(Settings.MUSIC_ON);
		(window as any).V.API.SlotAnalytics.setWinSounds(Settings.SOUNDS_ON);
	}

	protected onSpinStarted(): void {
		(window as any).V.API.SlotAnalytics.startSpinEvent();

		if (this._isFreeSpinsStarted) {
			this._lastSpinInteractionMethod = 'FreeSpin';
		} else if (this._isInAutoplay) {
			this._lastSpinInteractionMethod = 'AutoPlay';
		} else if (this._isSpinStartedSwiping) {
			this._lastSpinInteractionMethod = 'Swipe';
		} else if (this.device.isMobile) {
			this._lastSpinInteractionMethod = 'Tap';
		} else {
			if (this._wasQuickSpin) {
				this._lastSpinInteractionMethod = 'QuickSpin';
			} else {
				this._lastSpinInteractionMethod = 'Click';
			}
		}

		this._isSpinStartedSwiping = false;
		this._isInAutoplay = false;
		this._wasQuickSpin = false;
	}

	protected onCanSpin(): void {
		(window as any).V.API.SlotAnalytics.sendSpinEvent(this._lastSpinInteractionMethod, this._wasQuickSpin);
		this._wasQuickSpin = false;
	}
}



// WEBPACK FOOTER //
// ./src/integration/analytics/GameRecodeAnalyticsModule.ts